import { TypedUseSelectorHook, useSelector } from "react-redux";
import { ApplicationState } from "./ApplicationState";
import { rootReducer } from "./rootReducer";

export type RootState = ReturnType<typeof rootReducer>;

export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
